export default "__VITE_ASSET__48194e98__"